// core/routes/RuleChangeRoute.tsx  (or wherever these route files live)
import { Route } from 'react-router-dom';
import React, { Suspense } from 'react';

import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';
import NewRulePlanView from 'pages/ruleChange/NewRulePlanView';

const RuleChangeRoute = (
  <Route path={routeName.ruleChangePlans}>
    <Route
      path="create"
      element={
        <PrivateRoute name={[PrivateRouteConst.CREATE_RULE_PLANS]}>
          <Suspense fallback={<Loading />}>
            <NewRulePlanView pageType="Create" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.RULE_PLANS_EDIT,
            PrivateRouteConst.SELF_RULE_PLANS_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <NewRulePlanView pageType="Edit" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.RULE_PLANS_VIEW,
            PrivateRouteConst.SELF_RULE_PLANS_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <NewRulePlanView pageType="Show" />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default RuleChangeRoute;
